import type * as core from '../../../../../../../core'

export const PACKAGE = {
  contents: [
    'package:data.higherEd.orgStructureSpace',
    'package:data.higherEd.spaceUsage',
    'resource:data.dimensions.payrollExpenseSpace.entities.entry.attributes.payrollExpense',
    'resource:data.dimensions.payrollExpenseSpace.entities.entry.attributes.space',
    'resource:data.dimensions.payrollExpenseSpace.entities.entry',
    'resource:data.dimensions.payrollExpenseSpace',
    'resource:data.dimensions.serviceCenterFunctionalization.entities.entry.attributes.serviceCenter',
    'resource:data.dimensions.serviceCenterFunctionalization.entities.entry.attributes.spaceFunction',
    'resource:data.dimensions.serviceCenterFunctionalization.entities.entry.attributes.weight',
    'resource:data.dimensions.serviceCenterFunctionalization.entities.entry',
    'resource:data.dimensions.serviceCenterFunctionalization',
    'resource:data.dimensions.serviceCenters.entities.serviceCenter',
    'resource:data.dimensions.serviceCenters',
    'resource:data.dimensions.serviceCenterSpace.entities.entry.attributes.serviceCenter',
    'resource:data.dimensions.serviceCenterSpace.entities.entry.attributes.space',
    'resource:data.dimensions.serviceCenterSpace.entities.entry',
    'resource:data.dimensions.serviceCenterSpace',
    // TODO: We might want to move this elsewhere to support RP, but for now it
    // is here because this only used for the Rate application
    'resource:data.dimensions.spaceFunctions.entities.function.records.unassignable',
    'resource:data.dimensions.spaceFunctions.entities.function.records.vacant',
  ],
  description: 'TODO',
  name: 'IDC Data - Dependencies',
} as const satisfies core.quiver.Package
